import {XHTTP} from '@/shared/xhttp';
import {LongueursVenteService} from '@/xhttp';

@XHTTP(LongueursVenteService, '/longueurs-ventes')
export class LongueursVente {
	
	private _id: number;
	private _listOrder: number;
	private _name: string;
	private _use: boolean;
	
	/////////////
	// Getters //
	/////////////
	
	get id(): number {
		return this._id;
	}

	public get listOrder(): number {
		return this._listOrder;
	}
	
	public get name(): string {
		return this._name;
	}

	public get use(): boolean {
		return this._use;
	}
	
	/////////////
	// Setters //
	/////////////

	public set listOrder(value: number) {
		this._listOrder = value;
	}
	
	public set name(value: string) {
		this._name = value;
	}

	///////////////
	// Serialize //
	///////////////

	public toJSON(): any {
		return {
			id     : this._id,
			listOrder       : this._listOrder,
			name   : this._name,
		};
	}
	
	public fromJSON(data: any): this {
		this._id   = data.id;
		this._listOrder        = data.listOrder;
		this._name = data.name;
		this._use  = data.use;
		return this;
	}

	////////////
	// Others //
	////////////
	
	public toString(): string {
		return this.name;
	}
	
}